var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile"},[_c('div',{staticClass:"text-center"},[_c('img',{staticClass:"face",attrs:{"src":_vm.userData.face||'https://api.bigemap.com/uploads/face/20210617/16238961269877.png',"alt":""}})]),_c('div',{staticClass:"username"},[_vm._v(" "+_vm._s(_vm.userData.nickname||_vm.userData.username)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }